export default function HomeSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '17.3关于性教育宣传片',
        url: 'https://www.173sexeducation.org',
        description: '专为青少年设计的科学性教育视频内容，涵盖青春期知识、健康观念与自我保护意识。',
        foundingDate: '2020',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-123-4567',
          contactType: 'customer service',
          areaServed: 'CN',
          availableLanguage: 'Chinese',
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebSite',
        name: '17.3关于性教育宣传片',
        url: 'https://www.173sexeducation.org',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.173sexeducation.org/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '首页 - 17.3关于性教育宣传片',
        description: '17.3关于性教育宣传片是专为青少年设计的科学性教育视频内容，涵盖青春期知识、健康观念与自我保护意识。',
        url: 'https://www.173sexeducation.org',
        isPartOf: {
          '@type': 'WebSite',
          name: '17.3关于性教育宣传片',
        },
        about: {
          '@type': 'Thing',
          name: '青少年性教育',
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}